import moment from 'moment';

import { Http } from '../../../support';

const from = moment().subtract(1, 'month').format('YYYY-MM-DD');
const to = moment().format('YYYY-MM-DD');

export const initialState = {
  busy: false,
  data: [],
  selectedRows: [],
  selectedRowKeys: [],
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
    from,
    to,
  },
};

const setSelectedRows = (store, data) => {
  store.setState((state) => {
    state.modulo.catalogo.cliente.archivos = {
      ...state.modulo.catalogo.cliente.archivos,
      ...data,
    };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    state.modulo.catalogo.cliente.archivos.data = {
      ...state.modulo.catalogo.cliente.archivos.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    state.modulo.catalogo.cliente.archivos = {
      ...state.modulo.catalogo.cliente.archivos,
      result: undefined,
      error: undefined,
      busy: true,
      pagination: {
        ...state.modulo.catalogo.cliente.archivos.pagination,
        ...params,
      },
    };
  });

  try {
    const { pagination } = store.state.modulo.catalogo.cliente.archivos;

    const body = {
      ...pagination,
      ...params,
      links: undefined,
    };

    const response = await Http.get(`/api/catalogos/cliente/carta-porte`, { params: body });

    store.setState((state) => {
      state.modulo.catalogo.cliente.archivos = {
        ...state.modulo.catalogo.cliente.archivos,
        busy: false,
        data: response.data,
        pagination: {
          ...state.modulo.catalogo.cliente.archivos.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.catalogo.cliente.archivos.busy = false;
      state.modulo.catalogo.cliente.archivos.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.modulo.catalogo.cliente.archivos = {
      ...initialState,
    };
  });
};

const CatalogoClienteListStore = {
  state: () => initialState,
  actions: {
    change,
    setSelectedRows,
    paginate,
    reset,
  },
};

export default CatalogoClienteListStore;
